module.exports = __webpack_public_path__ + "static/media/wt.b1fc8446.mp4";